import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { ThemeService } from '../../../infrastructure/theme/theme.service';

@Component({
  selector: 'app-application-confirmation',
  templateUrl: './application-confirmation.component.html',
  styleUrls: ['./application-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioButtonComponent, TranslatePipe]
})
export class ApplicationConfirmationComponent {
  private themeService = inject(ThemeService);

  readonly header = input<string>(undefined);
  readonly description = input<string>(undefined);
  readonly buttonText = input<string>(undefined);
  readonly showButton = input(true);
  readonly buttonClicked = output();

  public get logo(): string {
    return (
      this.themeService?.getActiveTheme?.logo?.url ||
      '/assets/images/logos/logo-immomio-main.svg'
    );
  }
}
